import{isProdEnv as r,isBetaEnv as o}from"../utils/env.js";var t=r||o?3:1;export{t as CORVA_COMPANY_ID};
